// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2099":"393c4cdf","9668":"393c4cdf"}[chunkId] + ".chunk.css";
};